import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { isLoggedin } from "./components/utils/common";

import TopHeader from "./components/layout/TopHeader";
import TopFooter from "./components/layout/TopFooter";
import Dashboard from "./components/pages/Dashboard";
import Login from './components/pages/Login';
import BatchOperations from "./components/pages/BatchOperations";
import BatchHistory from "./components/pages/BatchHistory";
import MyFarms from "./components/pages/MyFarms";
import Mortality from "./components/pages/Mortality";
import GrowthCurve from "./components/pages/GrowthCurve";
import GrowthCurveNew from "./components/pages/GrowthCurveNew";
import DeviceManagement from "./components/pages/DeviceManagement";
import SensorCalibration from "./components/pages/SensorCalibrations";
import Templates from "./components/pages/Templates";
import BatchMaster from "./components/pages/AddBatch";
import FarmMaster from "./components/pages/AddBarn";
import Users from "./components/pages/Users";
import AddUser from "./components/pages/AddUser";
import BatchSummary from "./components/pages/BatchSummary";
import ForgotPassword from "./components/pages/ForgotPassword";
import ManageFans from "./components/pages/ManageFans";
import IdealsComparison from "./components/pages/IdealsComparison";
import BatchComparison from "./components/pages/BatchComparison";
import AvgBirdWeightComparison from "./components/pages/AvgBirdWeightComparison";
import FCRComparison from "./components/pages/FCRComparison";
import GrowthComparison from "./components/pages/GrowthComparison";
import SetPassword from "./components/pages/SetPassword";
import MyProfile from "./components/pages/MyProfile";
import AddTemplates from "./components/pages/AddTemplates";
import AppVideos from "./components/pages/AppVideos";
import Videos from "./components/pages/Videos";
import DailyOperationsReport from "./components/pages/DailyOperationsReport";
import ControlSystems from "./components/pages/ConstrolSystem";
import Integrators from "./components/pages/Integrators";
import BatchMortlaity from "./components/pages/BatchMortality";
import HeatStressAnalytics from "./components/pages/HeatStressAnalytics";
import ChickenChatWidget from "./components/chat/ChickenChatWidget";
import { ConfigProvider } from "antd";
import { useTranslation } from "react-i18next";
import { getAntdLocale } from "./i18n/antdLocale";
// The signed-out pages, grouped in one child of the top-level <Switch>.
//
// Each page animates itself IN on mount (AuthLayout's entrance choreography);
// there is deliberately no AnimatePresence here. It was tried with
// mode="wait", and the exiting page never signalled that it had finished
// exiting — so navigating changed the URL while the old page stayed on
// screen. That only showed up once BOTH pages had an exit animation; before
// that, one side had nothing to wait for and it appeared to work. An
// enter-only transition looks the same to the user and cannot hang.
const PublicRoutes = () => (
  <Switch>
    <Route exact path="/" component={Login}></Route>
    <Route exact path="/login" component={Login}></Route>
    <Route exact path="/validate/:user" component={SetPassword}></Route>
    <Route exact path="/forgotpassword" component={ForgotPassword}></Route>
  </Switch>
);

function App() {

  // antd components (currently the tables on BatchMortality) get their built-in
  // strings — pagination, "No data", sort/filter tooltips — from this provider.
  const { i18n } = useTranslation();

  return (
    <ConfigProvider locale={getAntdLocale(i18n.language)}>
    <Router>
      <div className="App">
        <Switch>
          {/* One entry for all four public routes; PublicRoutes re-matches
              them internally. matchPath accepts an array (it does
              `[].concat(path)`), and element children of a <Route> render
              only when it matches. */}
          <Route exact path={["/", "/login", "/validate/:user", "/forgotpassword"]}>
            <PublicRoutes />
          </Route>
          {/* Everything below is behind a session. This <Route> carries no
              `path`, so <Switch> treats it as the catch-all for every route
              above; it must stay AFTER the public routes so those match first
              and /login stays reachable. Signed-out visitors are redirected
              rather than rendering TopHeader/Dashboard against a missing
              'user', which used to give a blank page.

              The gate MUST live inside a <Route> and not as a bare
              `{!isLoggedin() && <Redirect/>}` child: <Switch> picks its child
              out of App's LAST render, and App re-renders only on a language
              change (useTranslation is its only subscription). A <Redirect>
              computed while signed out therefore stayed in the children array
              and — being pathless, so matchPath is skipped and context.match
              always matches — swallowed the post-login push to /dashboard,
              bouncing the user straight back to /login. A <Route>'s `render`
              re-runs on every navigation, so isLoggedin() is read at match
              time instead of being frozen into a stale render. */}
          <Route
            render={() =>
              !isLoggedin() ? (
                <Redirect to="/login" />
              ) : (
                <div className="wrapper">
                  <TopHeader />
                  <div className="content myappcontent">
                    <div className="container-fluid">
                      <Route exact path="/dashboard" component={Dashboard}></Route>
                      <Route exact path="/batchOperations" component={BatchOperations}></Route>
                      <Route exact path="/batchHistory" component={BatchHistory}></Route>
                      <Route exact path="/listofbarns" component={MyFarms}></Route>
                      <Route exact path="/mortality" component={Mortality}></Route>
                      <Route exact path="/growthcurve" component={GrowthCurve}></Route>
                      <Route exact path="/growthcurvenew" component={GrowthCurveNew}></Route>
                      <Route exact path="/managedevices" component={DeviceManagement}></Route>
                      <Route exact path="/sesorcalibration" component={SensorCalibration}></Route>
                      <Route exact path="/templates" component={Templates}></Route>
                      <Route exact path="/addBatch" component={BatchMaster}></Route>
                      <Route exact path="/addBarn" component={FarmMaster}></Route>
                      <Route exact path="/users" component={Users}></Route>
                      <Route exact path="/adduser" component={AddUser}></Route>
                      <Route exact path="/managefans" component={ManageFans}></Route>
                      <Route exact path="/batchSummary/:data" component={BatchSummary}></Route>
                      <Route exact path="/idealweightcomparison/" component={IdealsComparison}></Route>
                      <Route exact path="/batchcomparison/" component={BatchComparison}></Route>
                      <Route exact path="/avgbirdweightcomparison/" component={AvgBirdWeightComparison}></Route>
                      <Route exact path="/fcrcomparison/" component={FCRComparison}></Route>
                      <Route exact path="/growthcomparison/" component={GrowthComparison}></Route>
                      <Route exact path="/myprofile/" component={MyProfile}></Route>
                      <Route exact path="/addtemplates/" component={AddTemplates}></Route>
                      <Route exact path="/appVideos/" component={AppVideos}></Route>
                      <Route exact path="/dopReport/" component={DailyOperationsReport}></Route>
                      <Route exact path="/controlSystem/" component={ControlSystems}></Route>
                      <Route exact path="/integrators/" component={Integrators}></Route>
                      <Route exact path="/batchmortality/" component={BatchMortlaity}></Route>
                      <Route exact path="/heatstressanalytics/" component={HeatStressAnalytics}></Route>
                    </div>
                  </div>
                  <TopFooter />
                  <ChickenChatWidget />
                </div>
              )
            }
          />
        </Switch>
      </div>
    </Router>
    </ConfigProvider>
  );
}

export default App;
